import styled from 'styled-components';
import { Col, Row } from 'components/grid';

import DividerLine from 'components/dividerLine';
import List from 'components/list';
import DraggableList from 'components/draggableList';

const ColumnTypeText = styled.p`
  ${({ theme }) => theme.typograph.subTitleMedium}
  color: ${({ theme }) => theme.colors.mainColorContrast};
  margin-bottom: 8px;
`;

const SaveButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 48px;
`;

const DividerLineStyled = styled(DividerLine)`
  margin-bottom: 32px;
`;

const ListStyled = styled(List)`
  margin-bottom: 32px;
`;

const DraggableListStyled = styled(DraggableList)`
  margin-bottom: 32px;
`;

const StyledCol = styled(Col)`
  display: flex;
  justify-content: center;
`;

const StyledHeader = styled(Row)`
  margin-bottom: 8px;
  margin-left: 32px;
  ${({ theme }) => theme.typograph.subTitleMedium}
`;

const StyledColField = styled(Col)`
  padding-left: 16px;
  display: flex;
  align-items: center;
`;

const Wrapper = styled.div`
  margin-bottom: 32px;
`;

const StyledColForList = styled(Col)`
  display: flex;
  align-items: center;
`;

const ModificationsText = styled.p`
  ${({ theme, hasModification }) => (hasModification ? theme.typograph.paragraphMedium : theme.typograph.paragraphRegular)};
  color: $${({ theme, hasModification }) => (hasModification ? theme.colors.mainColor : theme.colors.textColorSecondary)};
  margin-right: 24px;
`;

export {
  ColumnTypeText,
  SaveButtonWrapper,
  DividerLineStyled,
  StyledCol,
  StyledColField,
  Wrapper,
  StyledHeader,
  ListStyled,
  DraggableListStyled,
  StyledColForList,
  ModificationsText,
};
